import React from 'react';
import { formatDate } from '../../../../../../../Invoices/InvoiceHub/utils';

export const BillNumberRenderer = ({ billNumber, createTime } : { billNumber: string, createTime: string }) => (
  <>
    <div data-testid='BillsHub__table-column-bill-number' className='truncate'>{`#${billNumber}`}</div>
    <div>{formatDate(createTime, true)}</div>
  </>
);
